<template>
  <div>
    <pageHeader :headerIcon="'calendar alternate outline'"
                :headerText="$t('calendar')"
                :haveFilterInput="false">
    </pageHeader>
    <div v-if="loading" class="ui active inverted dimmer">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <fullCalendar :events="formatReservations()" style="padding-top: 25px" v-else></fullCalendar>
  </div>
</template>

<script>
export default {
  components: {
    fullCalendar: require('@/components/abstract_components/FullCalendar').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      reservations: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get('reservations/calendar').then(response => {
      this.reservations = response.data
      this.loading = false
    })
  },
  methods: {
    formatReservations () {
      let calendarEvents = []

      window._.each(this.reservations, reservation => {
        calendarEvents.push({
          title: `${this.$t('patientName')} # ${reservation.patient_name} `,
          start: window.moment(reservation.time).toDate(),
          end: this.getTime(reservation),
          allDay: false
        })
      })

      return calendarEvents
    },
    getTime (reservation) {
      let reservationType = this.reservationTypes.find(reservation.reservation_type_id)

      if (reservation.cancelled_at || this.getReservationStatus(reservation) === this.$t('passed')) {
        // in case reservation cancelled or passed
        return window.moment(reservation.time).toDate()
      } else if (reservation.started_at && reservation.finished_at) {
        // in case reservation process completed
        return window.moment(reservation.finished_at).toDate()
      } else if (reservation.started_at && !reservation.finished_at) {
        // in case reservation process in progress
        return this.getEndTime(reservation.started_at, (reservationType.duration / 3600))
      } else if (!reservation.started_at && !reservation.finished_at) {
        // in case reservation proces is pending
        return this.getEndTime(reservation.time, (reservationType.duration / 3600))
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/calendar/Calendar.vue